import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { createCustomer } from "@/api";

export const useCreateCustomer = () => {
  return useMutation<
    unknown,
    AxiosError,
    { Email: string; Secret: string; Name: string, MarketingOptIn: boolean }
  >((payload) => {
    console.info("Signing up a new customer");
    return createCustomer(payload);
  });
};
